import { Controller } from "@hotwired/stimulus";

const youtubePattern =
  /^https:\/\/(([^\.]+\.)?youtube\.com\/watch\?.*?v=|youtu\.be\/)([a-zA-Z0-9_-]{11}).*/;
const vimeoPattern = /^https:\/\/(([^\.]+\.)?vimeo\.com\/)([0-9]{10}).*/;
const html5Pattern = /^(http|https):\/\/.*\.(mp4|webm|ogg)/;

export default class extends Controller {
  static values = { videoUrl: String };

  connect() {
    const youtubeMatches = this.videoUrlValue.match(youtubePattern);
    const vimeoMatches = this.videoUrlValue.match(vimeoPattern);
    const html5Matches = this.videoUrlValue.match(html5Pattern);

    if (youtubeMatches) {
      const videoId = youtubeMatches[3];
      this.embedVideo(this.buildYoutubeEmbed(videoId));
    } else if (vimeoMatches) {
      const videoId = vimeoMatches[3];
      this.embedVideo(this.buildVimeoEmbed(videoId));
    } else if (html5Matches) {
      const type = `video/${html5Matches[2]}`;
      this.embedVideo(this.buildHtml5Embed(this.videoUrlValue, type));
    } else {
      console.warn(
        "URL provided for video embed does not appear to be a Youtube, Vimeo, or compatible video file URL.",
      );
    }
  }

  buildYoutubeEmbed(id) {
    return `<iframe src="https://www.youtube.com/embed/${id}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
  }

  buildVimeoEmbed(id) {
    return `<iframe src="https://player.vimeo.com/video/${id}" referrerpolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"   allowfullscreen></iframe>`;
  }

  buildHtml5Embed(url, type) {
    return `<video controls><source src="${url}" type="${type}"></video>`;
  }

  embedVideo(embedHtml) {
    this.element.innerHTML = embedHtml;
  }
}
